import React from 'react';
import { TypographyProps } from './Typography.types';
import { themes, darkOverrides } from './TypographyThemes';
import { useIsDarkBackground } from 'src/contexts';
import { useIsDarkMode } from 'src/hooks/useIsDarkMode';
import { useCmsTheme } from 'src/contexts/CmsThemeContext/CmsThemeContextProvider';
import styled from 'threads5/styles/styled';

const Typography = React.forwardRef(
  (
    {
      children,
      className = '',
      variant = 'p', // how the element looks
      theme: styleTheme = 'default',
      component, // semantic element
      sx,
      ...props
    }: TypographyProps,
    ref,
  ) => {
    const isDarkMode = useIsDarkMode();
    const isDarkBackground = useIsDarkBackground();

    // If no matching variant is found, fall back to an unstyled tag
    const Component = themes[styleTheme][variant] ?? styled('span')({});

    const cmsTheme = useCmsTheme();
    return (
      <Component
        ref={ref}
        as={component} // this is a styled component prop that renders the specified tag
        sx={{
          // TODO: once the migration is complete we can do away with this logic and just rely on semantic tokens
          ...((isDarkBackground || isDarkMode) && {
            ...darkOverrides[cmsTheme],
          }),
          ...sx,
        }}
        className={className}
        cmsTheme={cmsTheme}
        data-text-node={variant ?? undefined}
        data-text-theme={styleTheme}
        {...props}
      >
        {children}
      </Component>
    );
  },
);

export default Typography;
